import React, { Component } from 'react'

export default ({ className, width, height }) => {
  return (

    <svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16.5 16.79" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>search</title>
      <path fill="#f1f1f1" d="M16.3,15.9l-4.2-4.2c2.4-2.6,2.5-6.5,0.3-9.2c-2.4-3-6.9-3.4-9.9-1c-3,2.4-3.4,6.9-1,9.9c2.4,3,6.9,3.4,9.9,1
    		l4.2,4.2c0.2,0.2,0.5,0.2,0.7,0C16.5,16.4,16.5,16.1,16.3,15.9z M7,13c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6s6,2.7,6,6
    		C13,10.3,10.3,13,7,13z"/>
    </svg>

  )
}



// WEBPACK FOOTER //
// ./src/components/visuals/Search.js